<template>
    <div class="max-w-(--breakpoint-sm) flex flex-col gap-4">
        <page-header>Billing Details</page-header>

        <org-unit-billing-email
            :team-id="orgUnit.team_id"
            :org-unit-id="orgUnit.id"
            :billing-email="orgUnit.billing_email"
            :is-editable="isEditable"
        />

        <org-unit-billing-info
            :team-id="orgUnit.team_id"
            :org-unit-id="orgUnit.id"
            :billing-information="{
                billing_company_legal_name: orgUnit.billing_company_legal_name,
                billing_address: orgUnit.billing_address,
                billing_address_line_2: orgUnit.billing_address_line_2,
                billing_city: orgUnit.billing_city,
                billing_state: orgUnit.billing_state,
                billing_zip: orgUnit.billing_zip,
                billing_country: orgUnit.billing_country,
                billing_po_number: orgUnit.billing_po_number,
            }"
            :is-editable="isEditable"
        />

        <org-unit-stripe-payment-method
            v-if="isEditable && stripeKey"
            :team-id="orgUnit.team_id"
            :org-unit-id="orgUnit.id"
            :payment-method="{ card_brand: orgUnit.card_brand, card_last_four: orgUnit.card_last_four }"
            :stripe-key="stripeKey"
            :stripe-api-version="stripeApiVersion"
        />
    </div>
</template>

<script setup>
import PageHeader from '~/components/general/PageHeader.vue';
import OrgUnitBillingEmail from '~/components/settings/billing/OrgUnitBillingEmail.vue';
import OrgUnitBillingInfo from '~/components/settings/billing/OrgUnitBillingInfo.vue';
import OrgUnitStripePaymentMethod from '~/components/settings/billing/OrgUnitStripePaymentMethod.vue';
import { computed } from 'vue';

const props = defineProps({
    orgUnit: {
        type: Object,
        required: true,
    },
    isAdminOrOwner: {
        type: Boolean,
        default: false,
    },
});

const stripeKey = Spark.stripeKey;
const stripeApiVersion = Spark.stripeApiVersion;

const isEditable = computed(() => props.isAdminOrOwner && props.orgUnit.is_billable);
</script>
